import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router'
import { fontSizes, fontWeights } from '../../Components/Common/Typography/TypographyStyles'

const UnauthorizedPage = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate('/overview')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Typography
        variant='h4'
        color='error'
        sx={{ fontWeight: fontWeights[700], fontSize: fontSizes.size64 }}
      >
        Unauthorized
      </Typography>
      <Typography variant='body1' sx={{ marginY: 2, fontSize: fontSizes.size16s }}>
        You do not have permission to access this page.
      </Typography>
      <Button variant='contained' color='primary' onClick={handleGoBack}>
        Go Back
      </Button>
    </Box>
  )
}

export default UnauthorizedPage
